import React from "react"
import {
    Button,
    Input,
    TrashCanIcon
} from "@fluentui/react-northstar"

import { ICheckboxData } from "./Types"

export interface ICheckboxFormProps {
    checkbox: ICheckboxData;
    checkboxTitleChanged: any;
    deleteCheckboxClick: any;
}

export default function CheckboxForm(props: ICheckboxFormProps) {
    return (
        <React.Fragment key={props.checkbox.id}>
            <Input className="inputField"
                fluid
                value={props.checkbox.title}
                label="Titulo de la opcion"
                placeholder="Titulo de la opcion"
                onChange={(event) => props.checkboxTitleChanged(event, props.checkbox.id)}
                autoComplete="off"
            />
            <Button className="inputButton"
                icon={<TrashCanIcon />}
                iconOnly
                title="Close"
                onClick={() => props.deleteCheckboxClick(props.checkbox.id)}
            />
        </React.Fragment>
    )
}
